







































import { defineComponent, watch, } from '@vue/composition-api'

export default defineComponent({
  props: {
    dialogSummary: {
      type: Boolean,
      required: true,
    },
    score: {
      type: Number,
      required: true,
    }
  },

  setup(props, context) {
    function updateRecord(): void {
      const currentRecord = localStorage.getItem('record') !== null
                              ? Number(localStorage.getItem('record'))
                              : null
      if (currentRecord === null || props.score < currentRecord) {
        localStorage.setItem('record', String(props.score))
      }
    }

    function playAgain(): void {
      context.emit('playAgain')
    }

    watch(
      () => props.dialogSummary,
      (newVal: boolean, oldVal: boolean) => {
        if (newVal === true) {
          updateRecord()
        }
      }
    )

    return {
      playAgain,
    }
  }
})
